var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarsFilterSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.48031C4 5.83869 4.51071 5.32031 5.14286 5.32031H18.8571C19.4893 5.32031 20 5.83869 20 6.48031C20 7.12194 19.4893 7.64031 18.8571 7.64031H5.14286C4.51071 7.64031 4 7.12194 4 6.48031ZM6.28571 12.2803C6.28571 11.6387 6.79643 11.1203 7.42857 11.1203H16.5714C17.2036 11.1203 17.7143 11.6387 17.7143 12.2803C17.7143 12.9219 17.2036 13.4403 16.5714 13.4403H7.42857C6.79643 13.4403 6.28571 12.9219 6.28571 12.2803ZM14.2857 18.0803C14.2857 18.7219 13.775 19.2403 13.1429 19.2403H10.8571C10.225 19.2403 9.71429 18.7219 9.71429 18.0803C9.71429 17.4387 10.225 16.9203 10.8571 16.9203H13.1429C13.775 16.9203 14.2857 17.4387 14.2857 18.0803Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsFilterSolid);
export default __webpack_public_path__ + "static/media/bars-filter-solid.d249414b508da26b918d1a7570cedde0.svg";
export { ForwardRef as ReactComponent };